import { render, staticRenderFns } from "./bar-order-item.vue?vue&type=template&id=1c54c5c9&"
import script from "./bar-order-item.vue?vue&type=script&lang=ts&"
export * from "./bar-order-item.vue?vue&type=script&lang=ts&"
import style0 from "./bar-order-item.vue?vue&type=style&index=0&id=1c54c5c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports